import { useCallback } from 'react';

import { useCookies } from 'react-cookie';

import getDeviceFingerprint from '@/lib/utils/getDeviceFingerprint';
import { APP_CONFIG_CONSTANTS } from '../../constants/appConfig.constants';

const isProd = import.meta.env.VITE_ENV_INSTANCE === 'PROD';

export const useDeviceFingerprint = () => {
  const [cookies, setCookie] = useCookies([
    APP_CONFIG_CONSTANTS.DEVICE_FINGERPRINT_COOKIE,
  ]);

  const getFingerprint = useCallback(async (): Promise<string> => {
    let fingerprint = cookies[APP_CONFIG_CONSTANTS.DEVICE_FINGERPRINT_COOKIE];

    if (!fingerprint) {
      try {
        fingerprint = await getDeviceFingerprint();
      } catch (error) {
        console.error('Failed to generate device fingerprint:', error);
        fingerprint = `fallback_${Date.now()}_${Math.random().toString(36).substring(2)}`;
      }

      setCookie(APP_CONFIG_CONSTANTS.DEVICE_FINGERPRINT_COOKIE, fingerprint, {
        path: '/',
        maxAge: APP_CONFIG_CONSTANTS.COOKIE_MAX_AGE,
        sameSite: 'lax',
        secure: isProd,
      });
    }

    return fingerprint;
  }, [cookies, setCookie]);

  return { getFingerprint };
};
